import type { EventPayload } from "./types";
import { configManager, log } from "./config";

const MAX_BEACON_SIZE = 64 * 1024; // 64KB
const MAX_RETRIES = 3;

/** 发送事件到后端 */
export function sendEvent(payload: EventPayload) {
  const url = `${configManager.apiEndpoint}/api/collect`;
  const body = JSON.stringify(payload);

  log("Sending event:", payload.event_name, payload);

  // 优先 sendBeacon（页面卸载安全）
  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    const blob = new Blob([body], { type: "text/plain" });
    if (blob.size < MAX_BEACON_SIZE) {
      const success = navigator.sendBeacon(url, blob);
      if (success) {
        log("Event sent via sendBeacon");
        return;
      }
    }
  }

  // 降级到 XHR + 重试
  sendWithXHR(url, body, MAX_RETRIES);
}

function sendWithXHR(url: string, body: string, retries: number) {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "text/plain");
  xhr.onreadystatechange = () => {
    if (xhr.readyState !== 4) return;
    if (xhr.status >= 200 && xhr.status < 300) {
      log("Event sent via XHR");
    } else if (retries > 0) {
      const delay = (MAX_RETRIES - retries + 1) * 1000; // 1s, 2s, 3s 递增延迟
      log(
        `XHR failed (${xhr.status}), retrying in ${delay}ms... (${retries} left)`
      );
      setTimeout(() => sendWithXHR(url, body, retries - 1), delay);
    } else {
      log("Event send failed after retries");
    }
  };
  xhr.send(body);
}
